import React, { useState, useEffect } from "react";
import { X } from "react-feather";
import "animate.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AlertPopup({
  confirmationPopupText,
  setConfirmationPopupVisibility,
}) {
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);
  const navigate = useNavigate();

  //#region localization code
  const { t, i18n } = useTranslation();
  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  return (
    <div className="pupup__container">
      <div
        className="pupup__container__from animate__animated animate__slideInDown"
        style={{ maxWidth: "500px" }}
      >
        <button
          className="pupup__container__from__button"
          type="button"
          onClick={() => {
            setConfirmationPopupVisibility(false);
          }}
          title="close popup"
        >
          <X size={16} color="var(--color-Primary)" />
        </button>
        <div className="pupup__container__from__top">
          <div
            className="pupup__container__from__top__left"
            style={{ width: "100%" }}
          >
            <div
              className="homepage__container__jumbotron__heading animate__animated animate__fadeInDown"
              style={{
                fontSize: "25px",
                textAlign: "center",
                marginTop: 0,
                color: "var(--color-Primary)",
              }}
            >
              {t("escape_spa")}
            </div>
            <div
              className="homepage__container__jumbotron__heading animate__animated animate__fadeInDown"
              style={{
                fontSize: "14px",
                textAlign: "center",
                marginTop: "1em",
              }}
            >
              {confirmationPopupText}
            </div>
            <div className="popup__buttons__wrapper">
              <button
                type="submit"
                className="Summary_Pay_Now_Button"
                style={{
                  margin: "0em auto",
                  marginTop: "2em",
                  height: "40px",
                  width: "150px",
                }}
                title="action button"
                onClick={() => {
                  setConfirmationPopupVisibility(false);
                  localStorage.removeItem("cartArr");
                  localStorage.removeItem("bookingArr");
                  localStorage.removeItem("selectedTimeSlot");
                  navigate("/bookingdetail");
                }}
              >
                {t("ok")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
